import { render, staticRenderFns } from "./AffiliateAdvisorPreviewItem.vue?vue&type=template&id=77568053&scoped=true&"
import script from "./AffiliateAdvisorPreviewItem.vue?vue&type=script&lang=ts&"
export * from "./AffiliateAdvisorPreviewItem.vue?vue&type=script&lang=ts&"
import style0 from "./AffiliateAdvisorPreviewItem.vue?vue&type=style&index=0&id=77568053&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77568053",
  null
  
)

export default component.exports